module.exports = __webpack_public_path__ + "img/laravel.497cb92.svg";